import LocaleUtils from "qwc2/utils/LocaleUtils";
import FeatureUtils from "./FeatureUtils";
import axios from "axios";
import ConfigUtils from "qwc2/utils/ConfigUtils";

let COMPONENTCACHE = null;

const ComponentUtils = {

    getAddUrl(type) {
        return ConfigUtils.getConfigProp("componentServiceUrl") + 'collections/' + type + '/items/';
    },

    getTypesUrl(type) {
        return ConfigUtils.getConfigProp("componentServiceUrl") + 'componenttype/collections/' + type + '/types/';
    },

    getAddComponents(success) {
        if (COMPONENTCACHE === null) {
            const url = ConfigUtils.getConfigProp("componentServiceUrl") + 'data/componenttypeswithproperities';
            axios(url).then(response => {
                COMPONENTCACHE = response;
                success(response);
            }).catch(error => {
                console.log("Error *** : " + error);
            });
        } else {
            success(COMPONENTCACHE);
        }
    },

    async getTabConfig(feature) {
        let url = '';
        if (feature.detailWindowUrl) {
            url = feature.detailWindowUrl.replace(/\/collections\/[^\/]+\/items\//, '/collections/component/items/');
        }
        if (feature.links) {
            feature.links.forEach((l) => {
                if (l.rel === 'self') {
                    url = l.href;
                    //console.log('New url', url);
                }
            });
        }

        const config = {
            type: feature.properties?.objectType || null,
            tabs: []
        };

        if (!url) {
            config.tabs.push({
                label: LocaleUtils.trmsg("featuredetails.addcomponent"),
                view: 'componentadd'
            });
        } else {
            console.log('Build tabs', feature);
            config.tabs.push(await this.getPropertyTab(feature));
            config.tabs.push(this.getFormTab(feature, {
                type: '',
                properties: {}
            }, url, 'patch'));

            config.tabs.push({
                label: LocaleUtils.trmsg("components.deactivate"),
                view: 'componentstatus',
                url: url.split("?")[0],
                config: {
                    label: 'Deaktivieren',
                    content: 'Hier können Sie das Bauteil deaktivieren.',
                    error: [
                        {
                            type: "message",
                            message: "Das Deaktivieren ist fehlgeschlagen."
                        }
                    ],
                    success: [
                        {
                            type: "message",
                            message: "Das Deaktivieren war erfolgreich."
                        }
                    ],
                    method: 'delete',
                    headers: {
                        "Authorization": "Bearer {token}",
                        "Content-Type": "application/json"
                    },
                }
            });
            config.tabs.push({
                label: LocaleUtils.trmsg("components.subs"),
                view: 'componentsubs'
            });
            config.tabs.push({
                label: LocaleUtils.trmsg("components.documents"),
                view: 'componentattachments',
                config: {
                    attachments: feature.attachments
                }
            });
        }

        return config;
    },

    getFormTab(feature, data, url, method) {
        const isAddForm = (method == 'post');
        const successActions = [
            {
                type: "message",
                message: "Das Speichern war erfolgreich."
            }
        ];
        if (isAddForm) {
            successActions.push({
                type: "opencomponent",
                url: this.getAddUrl(data.type) + '{guid}'
            });
        } else {
            successActions.push({
                type: "opencomponent",
                url: url
            });
        }
        const formTab = {
            label: LocaleUtils.trmsg("components.edit"),
            view: 'form',
            url: url,
            config: {
                buttonLabel: 'Speichern',
                success: successActions,
                error: [
                    {
                        type: "message",
                        message: "Das Speichern ist fehlgeschlagen."
                    }
                ],
                method: method,
                headers: {
                    "Authorization": "Bearer {token}",
                    "Content-Type": "application/json"
                }
            }
        };
        const fields = [];
        if (feature.attributes && feature.attributes.length) {
            // add the default geometry fields as readonly
            if (isAddForm) {
                fields.push({
                    name: 'geometry.coordinates[0]',
                    label: 'Latitude',
                    type: "text",
                    readonly: true,
                    validate: {
                        required: true
                    }
                });
                fields.push({
                    name: 'geometry.coordinates[1]',
                    label: 'Longitude',
                    type: "text",
                    readonly: true,
                    validate: {
                        required: true
                    }
                });
            }
            feature.attributes.forEach(a => {
                if (!a.guid) {
                    return;
                }
                //console.log('aKey', aKey, a.guid, feature.properties[aKey], data.properties[aKey]);
                let foundValue = false;
                if (a.guid in feature.properties) {
                    // look for the data in the guid based property
                    data.properties[a.guid] = feature.properties[a.guid];
                    foundValue = true;
                }
                if (!foundValue || data.properties[a.guid] === null) {
                    data.properties[a.guid] = '';
                }
                //console.log('aKey2', data.properties[aKey]);
                const field = {
                    name: 'properties.' + a.guid,
                    label: a.nameDe,
                    type: "text",
                    validate: {
                        required: false
                    }
                };
                if (a.hasEnumerator && a.enumerator && a.enumerator.values) {
                    field.type = 'select';
                    field.options = [];
                    a.enumerator.values.forEach(ev => {
                        if (data.properties[a.guid] === ev.nameDe) {
                            data.properties[a.guid] = ev.guid;
                        }
                        field.options.push({
                            label: ev.nameDe,
                            sort: (ev.nameDe || '').toLowerCase(),
                            value: ev.guid
                        });
                    });

                    field.options.sort((o1, o2) => (o1.sort > o2.sort) ? 1 : ((o2.sort > o1.sort) ? -1 : 0));
                } else {
                    switch (a.dataType) {
                        case 'Boolean':
                            field.type = 'select';
                            field.options = [{
                                label: 'Ja',
                                value: true
                            }, {
                                label: 'Nein',
                                value: false
                            }];
                            break;
                        case 'Time':
                        case 'Date':
                            field.type = 'date';
                            break;
                        case 'Integer':
                            field.type = 'integer';
                            break;
                        case 'Real':
                        case 'Float':
                        case 'Decimal':
                            field.type = 'decimal';
                            break;
                    }
                }
                if (a.unitCodeSymbol) {
                    field.postfix = a.unitCodeSymbol;
                }
                fields.push(field);
            });
        }
        formTab.config.fields = fields;
        formTab.config.data = data;
        console.log('Form tab data', feature, data, formTab);
        return formTab;
    },

    async getTypesForFeature(feature) {
        if (feature.properties && feature.properties.objectType) {
            const url = this.getTypesUrl(feature.properties.objectType);
            const types = await axios.get(url);
            if (types.data.types) {
                return types.data.types;
            }
        }
        if (feature.types) {
            return feature.types;
        }
        return null;
    },

    async getPropertyTab(feature) {
        const propertyTab = {
            label: LocaleUtils.trmsg("components.properties"),
            view: 'properties'
        };

        const types = await this.getTypesForFeature(feature);
        if (types && types.tabs) {
            if (types.tabs.view) {
                propertyTab.view = types.tabs.view;
            }
            if (types.tabs.config && types.tabs.config.properties) {
                const properties = [];
                types.tabs.config.properties.forEach(p => {
                    const dataType = feature?.attributes?.find(a => a.propertyCode === p.key)?.dataType || '';

                    if (p.hide === 'invisible') {
                        return;
                    }
                    if (p.unitSymbol) {
                        p.postfix = p.unitSymbol;
                    }
                    if (dataType === 'Boolean') {
                        if (!p.format) {
                            p.format = 'boolean';
                        }
                    }
                    properties.push(p);
                });
                propertyTab.config = {
                    properties: properties
                };
            }
        }
        return propertyTab;
    },

    async getObjectLabel(feature) {
        console.log('Get object label', feature);
        const types = await this.getTypesForFeature(feature);

        if (types) {
            let label = null;
            if (types.typeLabel) {
                label = types.typeLabel;
            }
            if (types.objectLabel) {
                label = types.objectLabel;
            }
            if (label) {
                label = FeatureUtils.genericResolve(feature, label);
                label = FeatureUtils.simpleProperty(feature, label);
                return label;
            }
        }
        return '?';
    },
    getBreadcrumbUrl(feature) {
        if (!feature) {
            return null;
        }
        if (!feature.links) {
            return null;
        }
        for (let i = 0; i < feature.links.length; i++) {
            const link = feature.links[i];
            if (link.rel === 'parents') {
                return link.href;
            }
        }
        return null;
    }
};

export default ComponentUtils;
